import { AdminCatalogProductImage } from '../../../api/types';
import { httpDelete, httpGet, httpPostForm } from '../../../api/httpClient';

export interface CategoryImageUpload {
  file: File;
  idempotencyKey: string;
  linkId?: number;
  revision: number;
}

export const categoryMediaApi = {
  get(categoryId: number): Promise<{ image: AdminCatalogProductImage | null }> {
    return httpGet(`/v1/catalog-category/${categoryId}/image`);
  },
  async upload(categoryId: number, request: CategoryImageUpload): Promise<void> {
    const form = new FormData();
    form.append('file', request.file);
    form.append('idempotency_key', request.idempotencyKey);
    if (request.linkId !== undefined) form.append('link_id', String(request.linkId));
    form.append('revision', String(request.revision));
    const result = await httpPostForm<{ status: string; error: string | null }>(`/v1/catalog-category/${categoryId}/image`, form);
    if (result.status !== 'done') {
      throw new Error(result.error || 'Не удалось загрузить картинку. Повторите попытку.');
    }
  },
  remove(categoryId: number, linkId: number): Promise<void> {
    return httpDelete(`/v1/catalog-category/${categoryId}/image/${linkId}`);
  },
};
